import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.styl'
import Vue from 'vue'
import App from './App.vue'
import '@/permission'
import router from './router'
import store from './store'
import './filters'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import Popup from './components/relation/index'

Vue.prototype.$popup = Popup.install // 全局的冲突弹框
Vue.prototype.$echarts = echarts
Vue.use(ElementUI)
// 公用URL
// Vue.prototype.$APIurl = 'http://192.168.0.33:10069/'
// Vue.prototype.$APIurl = 'https://gec-api.gecacademy.cn/educational/'
Vue.config.productionTip = false
// 权限校验公用方法
Vue.prototype.geturiJdiction = function (data: any) {
  return store.state.user.roles.some((item: any) => item.indexOf(data) > -1)
}
// 按钮权限
Vue.prototype.isShowButtonName = function (isShowName: any, list: any) {
  const obj = list && list.find((item: any) => item.pathName === isShowName)
  return obj && obj.isShow
}
// 校验文件类型
Vue.prototype.fileExtension = function (type: any) {
  return type.substring(type.lastIndexOf('.') + 1)
}
new Vue({ router, store, render: h => h(App) }).$mount('#app')
